import { render, staticRenderFns } from "./HealthPathsDurationStandardDeviationStatistics.vue?vue&type=template&id=7a85ac3a"
import script from "./HealthPathsDurationStandardDeviationStatistics.vue?vue&type=script&lang=ts"
export * from "./HealthPathsDurationStandardDeviationStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports